import { FC, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteIcon from '@mui/icons-material/Delete';
import { Paper } from '@mui/material';
import cn from 'classnames';

import { IMedicationInquiryCardProps } from './MedicationInquiryCard.interface';

import './style.scss';

const MedicationInquiryCard: FC<IMedicationInquiryCardProps> = ({
  className,
  data,
  isEditable,
  isDisabled = false,
  isRemovable,
  onSelect,
  onRemove,
}) => {
  const { t } = useTranslation();

  const handleSelect = useCallback(() => {
    onSelect(data);
  }, [onSelect, data]);

  const handleRemove = useCallback(() => {
    onRemove(data);
  }, [onRemove, data]);

  return (
    <Paper
      className={cn(
        'supplement-inquiry-card',
        { 'supplement-inquiry-card_disabled': isDisabled },
        className,
      )}
      title={data.name}
      elevation={2}
    >
      {/* Separate clickable card surface to avoid event collisions with clickable remove button below */}
      <div className="supplement-inquiry-card__surface" onClick={handleSelect} />

      <div className="supplement-inquiry-card__name">{data.name}</div>

      {isEditable && isRemovable && (
        <DeleteIcon
          className="supplement-inquiry-card__delete pointer"
          color="error"
          onClick={handleRemove}
        />
      )}
    </Paper>
  );
};

export default MedicationInquiryCard;
